import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import { GC_USER_ID } from '@/constants'
import { routinesListQuery } from '@/graphql/queries/routine'

import { Modal, Typography, Paper, GridList, GridListTile } from 'material-ui'
import List, { ListItem, ListItemText } from 'material-ui/List'
import EditIcon from 'material-ui-icons/Edit'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import Loading from './Loading'
import RoutineEditModal from './RoutineEdit'

@graphql(routinesListQuery, {
  name: 'routinesListQuery',
  options: () => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID)
    },
    refetchQueries: ['routinesListQuery']
  })
})
export default class RoutinesModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      openEdit: false,
      action: '',
      id: ''
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleEdit = (action, id) => {
    this.setState({ action: action })
    if (action === 'edit') {
      this.setState({ id: id })
    } else {
      this.setState({ id: '' })
    }
    this.setState({ openEdit: true })
  }

  handleCloseEdit = () => {
    this.setState({ openEdit: false })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddToday" style={{ borderRadius: 16 }}>
            {this.props.routinesListQuery.loading ? (
              <Loading />
            ) : (
              <div id="GetUpTime" className="divAddTpday">
                <List>
                  <ListItem divider>
                    <ListItemText
                      className="modalHealder"
                      primary={
                        <Typography
                          variant="body1"
                          style={{ fontSize: 18, color: 'grey' }}
                        >
                          Your routines
                        </Typography>
                      }
                    />

                    <IconButton
                      className="btn btn-default btn-style"
                      onClick={this.handleClose}
                    >
                      <ClearIcon className="iconClear" />
                    </IconButton>
                  </ListItem>
                </List>
                {
                  <GridList className="gridList" cols={4}>
                    {this.props.routinesListQuery &&
                      this.props.routinesListQuery.allRoutines &&
                      this.props.routinesListQuery.allRoutines.map(
                        (e, index) => (
                          <GridListTile
                            xs={6}
                            cols={1}
                            key={index}
                            style={{ height: 108 }}
                          >
                            <Paper
                              className="paperBlock"
                              style={{ borderRadius: 20 }}
                            >
                              <div
                                key={`bookblock-key-${index}`}
                                className="bookBlockSquare"
                                style={{
                                  backgroundColor: 'blue',
                                  opacity: 0.55
                                }}
                              >
                                <img
                                  alt=""
                                  className="iconTracker"
                                  src={
                                    process.env.PUBLIC_URL + '/cloud_done.png'
                                  }
                                />
                                <Typography
                                  variant="caption"
                                  style={{
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    textAlign: 'center',
                                    fontSize: 12,
                                    color: 'white',
                                    lineHeight: 1.1
                                  }}
                                >
                                  {e.name}
                                </Typography>
                              </div>
                              <div
                                onClick={() => this.handleEdit('edit', e.id)}
                                className="iconBtnEditSmallX"
                              >
                                <EditIcon
                                  style={{
                                    color: 'lightgrey',
                                    fontSize: 14
                                  }}
                                />
                              </div>
                            </Paper>
                          </GridListTile>
                        )
                      )}
                    <GridListTile
                      xs={6}
                      cols={1}
                      key={'add'}
                      style={{ height: 90 }}
                    >
                      <Paper
                        className="paperBlock"
                        style={{ borderRadius: 20 }}
                        onClick={() => this.handleEdit('add', '')}
                      >
                        <div
                          key={`bookblock-key-add`}
                          className="bookBlockSquare"
                          style={{ backgroundColor: 'white' }}
                        >
                          <img
                            alt=""
                            className="iconTracker"
                            src={process.env.PUBLIC_URL + '/cloud_done.png'}
                          />
                          <Typography
                            variant="body1"
                            id="bookName"
                            style={{
                              paddingLeft: 2,
                              paddingRight: 2,
                              textAlign: 'center',
                              fontSize: 12,
                              color: 'grey',
                              lineHeight: 1.1
                            }}
                          >
                            Add
                          </Typography>
                        </div>
                      </Paper>
                    </GridListTile>
                  </GridList>
                }
              </div>
            )}
          </Paper>
        </Modal>
        <RoutineEditModal
          open={this.state.openEdit}
          onClose={this.handleCloseEdit}
          id={this.state.id}
          action={this.state.action}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/Routines.js